"use strict";

import React, { Component } from "react";
import UrlHelper from "../../utilities/UrlHelper";
import * as Constants from "../../utilities/Constants";

export default class OrganizationProductsBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedProductName: UrlHelper.getProductNameFromUrl(true)
        };
    }

    isExcludedProduct (productName) {
        return productName === Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION || productName === Constants.ORGANIZATION_PRODUCT_QUANTIFI;
    }

    render() {
        const prevUrl = UrlHelper.sanitizeUrl(document.referrer);

        const productElements = [];

        const addProductElement = (key, title, url) => {
            if (this.isExcludedProduct(title))
                return;
            if (productElements.length > 0)
            {
                productElements.push(" / ");
            }
            productElements.push(
                <a href = {url} tabIndex="-1" id = {key} key = {key}>
                    <span>{title}</span>
                </a>
            );
        };

        if (this.props.products) {
            const idLogoPrefix = "logo";
            this.props.products.forEach(p => addProductElement(idLogoPrefix + p.productName, p.productName, p.adminUrl));

            const selectedUrl = this.props.products.find(product => {
                return product.productName === this.state.selectedProductName;
            });

            if (selectedUrl)
            {
                return (
                    <div id="OrganizationProductsBar">
                        <span className="glyphicon glyphicon-arrow-left" />
                        <span id="TextSpan">Admin Page for </span>
                        { productElements }
                    </div>
                );
            }
            else
            {
                return (

                    <div id="OrganizationProductsBar">
                        <span className="glyphicon glyphicon-arrow-left" />
                        <a href={prevUrl}><span id="TextSpan">Admin Page</span></a>
                    </div>
                );
            }
        }

        return null;
    }
}
